import { useEffect, useState } from 'react';

// ─────────────────────────────────────────────────────────────────────────────
// 🔑 A TOKEN PAGE TAKES ITS TOKEN ONCE, THEN HIDES IT (2026-11-03, hand-test decision e).
//
// Every password-reset page (borrower /reset-password, DoorlyDesk /admin/reset-password, DoorlyPro
// /doorlypro/reset-password, investor /market/reset-password) and the staff invite page arrive from an email link
// carrying ?token=. Left in the address bar it lands in browser history, and the page's own requests (fonts, scripts,
// images) could carry it out in the Referer. So:
//   1. the token is read ONCE, at first render, and kept in state (react-router's searchParams is not used for it —
//      a history.replaceState outside the router would leave it reading the stale URL);
//   2. the query string is removed from the address bar with history.replaceState (no reload, no new entry);
//   3. while the page is mounted, the document's referrer policy is no-referrer (a <meta name="referrer">), restored on
//      the way out. The hosting header (frontend/vercel.json, Referrer-Policy: no-referrer on these paths) covers the
//      first load; this covers arriving by client-side navigation.
// A refresh afterward has no token, and each page already says to use the link from the email.
// ─────────────────────────────────────────────────────────────────────────────
export const TOKEN_PAGE_REFERRER_POLICY = 'no-referrer';

export function readTokenOnce(search, param = 'token') {
  try { return new URLSearchParams(search || '').get(param) || ''; } catch (_) { return ''; }
}

export function useTokenFromLink(param = 'token') {
  const [token] = useState(() => readTokenOnce(typeof window !== 'undefined' ? window.location.search : '', param));
  useEffect(() => {
    if (window.location.search) {
      window.history.replaceState(window.history.state, document.title, window.location.pathname + window.location.hash);
    }
    let meta = document.querySelector('meta[name="referrer"]');
    const created = !meta;
    if (created) { meta = document.createElement('meta'); meta.setAttribute('name', 'referrer'); document.head.appendChild(meta); }
    const before = meta.getAttribute('content');
    meta.setAttribute('content', TOKEN_PAGE_REFERRER_POLICY);
    return () => {
      if (created) meta.remove(); else if (before != null) meta.setAttribute('content', before);
    };
  }, []);
  return token;
}
